import React, { useEffect, useState } from 'react';
import { usersApiClient, questionsApiClient } from '../services/api';

interface QuestionCounts {
  total: number;
  scenario: string | number;
}

const BackendStatus: React.FC = () => {
  const [status, setStatus] = useState<'loading' | 'connected' | 'error'>('loading');
  const [message, setMessage] = useState<string>('Checking connection...');
  const [questionCount, setQuestionCount] = useState<{total: number, scenario: string | number} | null>(null);
  
  useEffect(() => {
    const checkStatus = async () => {
      try {
        const res = await usersApiClient.get('/health');
        if (res.data && res.data.status && res.data.status.toLowerCase() === 'ok') {
          setStatus('connected');
          setMessage(`Connected to API (v${res.data.version || 'unknown'})`);
          
          // Get question counts using questions API client
          try {
            const questionRes = await questionsApiClient.get('/questions', {
              params: { limit: 1000 } // Get all questions for accurate count
            });
            
            if (Array.isArray(questionRes.data)) {
              const total = questionRes.data.length;
              
              // Check for scenario questions in the scenarios collection
              let scenarioCount = 0;
              try {
                const scenariosRes = await questionsApiClient.get('/scenarios');
                if (Array.isArray(scenariosRes.data)) {
                  scenarioCount = scenariosRes.data.length;
                }
              } catch (scenarioErr) {
                console.error('Error fetching scenarios:', scenarioErr);
              }
              
              // Also check for scenario questions in the questions collection (legacy)
              const scenarioQuestions = questionRes.data.filter((question: any) => 
                question.category?.toLowerCase().includes('scenario') || 
                question.explanation?.toLowerCase().includes('scenario') ||
                question.options?.some((option: any) => option.text?.toLowerCase().includes('scenario'))
              );
              
              const totalScenarios = scenarioCount + scenarioQuestions.length;
              const scenarioDisplay = totalScenarios > 0 ? totalScenarios : 'none found';
                
              setQuestionCount({
                total,
                scenario: scenarioDisplay
              } as QuestionCounts);
            }
          } catch (err) {
            console.error('Error fetching question counts:', err);
          }
        } else {
          setStatus('error');
          setMessage('API returned invalid response');
        }
      } catch (err) {
        setStatus('error');
        setMessage('Could not connect to API');
        console.error(err);
      }
    };
    
    checkStatus();
  }, []);
  
  return (
    <div className="text-center text-sm">
      <div className={`inline-flex items-center ${
        status === 'connected' ? 'text-green-400' : 
        status === 'error' ? 'text-red-400' : 'text-yellow-400'
      }`}>
        <div className={`w-3 h-3 rounded-full mr-2 ${
          status === 'connected' ? 'bg-green-400' : 
          status === 'error' ? 'bg-red-400' : 'bg-yellow-400'
        }`}></div>
        {message}
      </div>
      
      {questionCount && (
        <div className="mt-2 text-blue-300">
          <p>Questions: {questionCount.total} total, Scenarios: {questionCount.scenario}</p>
        </div>
      )}
    </div>
  );
};

export default BackendStatus; 